// React
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Components
import Tooltip from 'ui/components/Tooltip'

export class ReadOnlyModeDisabledComponent extends Component {
  static displayName = 'ReadOnlyModeDisabledComponent'

  static propTypes = {
    readOnlyMode: PropTypes.bool
  }

  render () {
    const { readOnlyMode, children } = this.props

    if (readOnlyMode) {
      return (
        <Tooltip
          direction="top"
          maxWidth={500}
          content="Briefly unavailable for scheduled maintenance."
        >
          <div style={{ pointerEvents: 'none', opacity: 0.6 }}>
            {children}
          </div>
        </Tooltip>
      )
    } else {
      return children
    }
  }
}

const mapStateToProps = (state, props) => {
  return {
    readOnlyMode: state.client.readOnlyMode
  }
}

export default reduxConnect(mapStateToProps)(ReadOnlyModeDisabledComponent)
